import React from 'react';
import './alertmodal.css';
import FilterPanel from './dashboardFilter';
import FinancialFilter from './financialfilter';

const FilterModal = ({userInfo,
            filterName,
            accounts, 
            subaccounts,
            subAccountsLocal,
            setSubAccountsLocal,
            locations, setLocations,
            filters, setFilters,
            getMultipleSubAccountLocations,
            destinations,
            loading,
            onSearch,
            setShowModal
        }) => {

    window.onclick = function (event) {
        var modal = document.getElementById("myModal");
        if (event.target == modal) {
            setShowModal(false)
        }
        if (event.target == modal) {
            setShowModal(false)     
        }
    }

    const onFirstClick = () => {
        setShowModal(false)
    
    }

    return (
      <div id="myModal" className="modal">
        {filterName == "Financial" ? (
          <FinancialFilter
            filterName={filterName}
            accounts={accounts}
            loading={loading}
            onSearch={onSearch}
            filters={filters}
            setFilters={setFilters}
          />
        ) : (
          <FilterPanel
            userInfo={userInfo}
            filterName={filterName}
            accounts={accounts}
            subaccounts={subaccounts}
            subAccountsLocal={subAccountsLocal}
            locations={locations}
            setLocations={setLocations}
            filters={filters}
            setFilters={setFilters}
            getMultipleSubAccountLocations={getMultipleSubAccountLocations}
            destinations={destinations}
            loading={loading}
            onSearch={onSearch}
            setSubAccountsLocal={setSubAccountsLocal}
          />
        )}
      </div>
    );
}

export default FilterModal;